// Section 19: Plague. 1.5% per season, any season. Plague seeded in 2 people (contagion 2x is
// the plague illness's own, Section 12). Choices: Quarantine (as fever), Carry on, or Close the
// gates (migration Closed for 4 seasons). Constants: config.events.plague.
import type { Config } from '../../config';
import { choiceOutcome, eventEntry, eventPrompt } from '../../core/content-helpers';
import { contagiousCount } from '../../core/queries';
import { defineEvent, noModifiers, type EventChoiceDef } from '../../core/registry';

export function plague(config: Config) {
  const c = config.events.plague;
  const quarantineFood = config.events['fever-outbreak'].quarantineFoodPerSick;
  const choices: EventChoiceDef[] = [
    {
      id: 'quarantine',
      label: 'Quarantine the sick',
      preview: (ctx) => [
        {
          key: 'quarantine',
          params: {
            people: contagiousCount(ctx.state, ctx.cfg),
            food: contagiousCount(ctx.state, ctx.cfg) * quarantineFood,
            seasons: c.quarantineSeasons,
          },
        },
      ],
      apply: (ctx, prompt) => [
        {
          kind: 'quarantine',
          active: true,
          untilTurn: ctx.season.turn + c.quarantineSeasons - 1,
        },
        choiceOutcome(prompt, 'quarantine', { seasons: c.quarantineSeasons }),
      ],
    },
    {
      id: 'carry-on',
      label: 'Carry on',
      preview: () => [{ key: 'carry-on', params: {} }],
      apply: (_ctx, prompt) => [choiceOutcome(prompt, 'carry-on')],
    },
    {
      id: 'close-gates',
      label: 'Close the gates',
      preview: () => [{ key: 'close-gates', params: { seasons: c.closeGatesSeasons } }],
      apply: (ctx, prompt) => [
        { kind: 'closeGates', untilTurn: ctx.season.turn + c.closeGatesSeasons - 1 },
        choiceOutcome(prompt, 'close-gates', { seasons: c.closeGatesSeasons }),
      ],
    },
  ];
  return defineEvent({
    id: 'plague',
    label: 'Plague',
    section: 'S19',
    baseWeight: c.baseChance,
    seasons: ['spring', 'summer', 'autumn', 'winter'],
    foreshadow: null,
    ledgerTag: 'plague',
    weight: (ctx) => (Object.keys(ctx.state.people).length > 0 ? c.baseChance : 0),
    text: () => eventEntry('plague', { seeded: c.seeded }),
    apply: (ctx) => [
      {
        kind: 'outbreak',
        illnessId: 'plague',
        min: c.seeded,
        max: c.seeded,
        source: 'event:plague',
      },
      eventPrompt(ctx, 'plague', choices, { defaultChoiceId: 'carry-on' }),
    ],
    choices,
    modifierTargets: [],
    modifiers: noModifiers,
  });
}
